(function() {
    const cartGetCookie = (name) => {
      const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
      return m ? decodeURIComponent(m[2]) : null;
    };
    const cartDeleteCookie = (name) => {
      document.cookie = name + "=; Max-Age=0; path=/";
    };
    const raw = cartGetCookie("cart_unselected");
    if (!raw) return;
    let items;
    try {
      items = JSON.parse(raw);
      if (!Array.isArray(items) || items.length === 0) {
        cartDeleteCookie("cart_unselected");
        return;
      }
    } catch (e) {
      cartDeleteCookie("cart_unselected");
      return;
    }
    window.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: items.map(i => ({
              id: i.id,
              quantity: i.quantity || 1
            }))
          })
        }).then(res => res.json())
        .then(cart => {
            document.dispatchEvent(new CustomEvent("cart.updated", { detail: cart }));
        })
        .finally(() => {
          cartDeleteCookie("cart_unselected");
        });
      }, 0);
    });
  })();